import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SEO from './components/SEO';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import './App.css';

const AboutPage = lazy(() => import('./pages/AboutPage'));
const FeaturesPage = lazy(() => import('./pages/FeaturesPage'));
const HowItWorksPage = lazy(() => import('./pages/HowItWorksPage'));
const ProblemsPage = lazy(() => import('./pages/ProblemsPage'));
const TechnologyPage = lazy(() => import('./pages/TechnologyPage'));
const DesignConsultationPage = lazy(() => import('./pages/DesignConsultationPage'));
const BlogPage = lazy(() => import('./pages/BlogPage'));
const ArticleAutomation = lazy(() => import('./pages/ArticleAutomation'));
const ArticleFutureDesign = lazy(() => import('./pages/ArticleFutureDesign'));
const FAQPage = lazy(() => import('./pages/FAQPage'));
const CareersPage = lazy(() => import('./pages/CareersPage'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'));
const TermsOfServicePage = lazy(() => import('./pages/TermsOfServicePage'));
const CookiePolicyPage = lazy(() => import('./pages/CookiePolicyPage'));
const DisclaimerPage = lazy(() => import('./pages/DisclaimerPage'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #FFF5E6 0%, #E6F2FF 100%)' }}>
    <div className="w-10 h-10 border-4 border-orange-200 border-t-orange-500 rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SEO />
        <ScrollToTop />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/problems" element={<ProblemsPage />} />
            <Route path="/technology" element={<TechnologyPage />} />
            <Route path="/design-consultation" element={<DesignConsultationPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/interior-design-automation" element={<ArticleAutomation />} />
            <Route path="/blog/future-of-interior-design" element={<ArticleFutureDesign />} />
            <Route path="/faqs" element={<FAQPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
